const getters = {
  headerBg: state => state.global.headerBg,
  webSocketIns: state => state.global.webSocketIns,
  emailText: state => state.global.emailText,
  createText: state => state.global.createText,
  webSocketStatus: state => state.global.webSocketStatus
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js